import { toast } from '@atlas-design-system/react';

/**
 * @example
 * returns response Promise object
 * const response = await useFetchWrapper('authCode').get('api/ExcelUploadFunction');
 * @param authCode will be used as 'x-functions-key' header
 */
export function useFetchWrapper(authCode) {

    return {
        get: request('GET'),
        post: request('POST'),
        put: request('PUT'),
        delete: request('DELETE')
    };

    function request(method) {
        return (endpoint, body) => {

            const requestOptions = {
                method,
                headers: { 'x-functions-key': authCode, mode: 'cors' }
            };
            if (body) {
                requestOptions.headers['Content-Type'] = 'application/json';
                requestOptions.body = JSON.stringify(body);
            }
            var url = `${process.env.REACT_APP_API_BASE_URL}${endpoint}`;
            return fetch(url, requestOptions).then(handleResponse);
        }
    }

    function handleResponse(response) {
        return response.text().then(text => {
            const data = text && JSON.parse(text);
            if (!response.ok) {
                if ([401, 403].includes(response.status) && authCode) {
                    // auto logout if 401 Unauthorized or 403 Forbidden response returned from api
                    localStorage.removeItem('auth');
                    //history.push('/');
                    // eslint-disable-next-line no-restricted-globals
                    location.reload();
                }

                const error = (data && data.message) || response.statusText;
                toast.error('Request failed. Check console for error details: ' + error,
                    { position: 'top-right', duration: 5000 });
                console.log(response);
                return Promise.reject(error);
            }

            return data;
        });
    }
}